import { datePickerPopperClassName } from '@components/core-ui/form-elements/DatePicker/helpers/datePickerPopperConfig';

export const isClickInsideDatePicker = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }

  return target.closest('.react-datepicker') !== null || target.closest(`.${datePickerPopperClassName}`) !== null;
};
